import { createElement, Fragment } from 'react';
import { parseAlgoliaHitHighlight } from '@algolia/autocomplete-preset-algolia';

function Highlight({ hit, attribute, tagName = 'mark', isLightMode }) {
  return createElement(
    Fragment,
    {},
    parseAlgoliaHitHighlight({ hit, attribute }).map(
      ({ value, isHighlighted }, index) => {
        if (isHighlighted) {
          return createElement(
            tagName,
            {
              key: index,
              style: {
                color: isLightMode ? 'black' : 'white'
              }
            },
            value
          );
        }

        return value;
      }
    )
  );
}

export default Highlight;
